import { render, staticRenderFns } from "./myAvailableCoinsComponnents.vue?vue&type=template&id=4e10364b&scoped=true"
import script from "./myAvailableCoinsComponnents.vue?vue&type=script&lang=js"
export * from "./myAvailableCoinsComponnents.vue?vue&type=script&lang=js"
import style0 from "./myAvailableCoinsComponnents.vue?vue&type=style&index=0&id=4e10364b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10364b",
  null
  
)

export default component.exports